module.exports = __webpack_public_path__ + "static/media/trash.ed03624b.svg";